import { useState } from 'react'
import { ROLE_SUGGESTIONS, isSuggestedRole } from '@aurora/core'

/**
 * How this person appears in the app: a suggested role, or their own word.
 * Used on sign-up and in the profile, so both offer the same choices.
 */
export function RolePicker({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  const [custom, setCustom] = useState(() => !!value && !isSuggestedRole(value))
  const showInput = custom || (!!value && !isSuggestedRole(value))
  return (
    <div className="seg seg-wrap" role="radiogroup" aria-label="How you appear">
      {ROLE_SUGGESTIONS.map((l) => (
        <button
          key={l}
          type="button"
          role="radio"
          aria-checked={!showInput && value === l}
          className={`seg-item${!showInput && value === l ? ' is-active' : ''}`}
          onClick={() => { setCustom(false); onChange(l) }}
        >
          {l}
        </button>
      ))}
      <button
        type="button"
        role="radio"
        aria-checked={showInput}
        className={`seg-item${showInput ? ' is-active' : ''}`}
        onClick={() => { setCustom(true); if (isSuggestedRole(value)) onChange('') }}
      >
        other…
      </button>
      {showInput && (
        <input
          className="seg-input is-active"
          placeholder="papa, teta, nana…"
          value={value}
          autoFocus
          onChange={(e) => onChange(e.target.value)}
        />
      )}
    </div>
  )
}
